import React from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "inherit",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const EditBase = ({
  className,
  elevation = 1,
  expanded = true,
  children
}) => {
  const classes = useStyles();

  if (!elevation) {
    return React.createElement("section", {
      className: className || classes.root,
      "aria-expanded": expanded
    }, children);
  }

  return React.createElement(Paper, {
    elevation: elevation,
    square: true,
    className: className || classes.root,
    "aria-expanded": expanded
  }, children);
};

export default EditBase;